<template>
	<div class="empty-state-block d-flex flex-column align-center justify-center pa-3">
		<slot name="icon">
			<ao-icon
				v-if="iconName"
				:iconName="iconName"
				class="icon"
			/>
		</slot>
		<slot name="info">
			<div class="d-flex flex-column align-center mb-6">
				<slot name="title">
					<div class="ao-p1 text-textSecondary700 mb-2 text-center">{{ title }}</div>
				</slot>
				<slot name="subtitle">
					<div class="d-flex flex-column align-center ao-p2-regular text-textSecondary700">
						<span class="text-center">{{ subtitle }}</span>
					</div>
				</slot>
			</div>
		</slot>
		<div v-if="showButton">
			<slot name="button">
				<ao-btn
					class="d-flex align-center"
					color="primary"
					@click="$emit('click:action', $event)"
				>
					<!-- <ao-icon
						class="mr-1 ao-h1"
						iconName="plusCircle"
					/> -->
					<span class="ao-p1">{{ $t('Add') }}</span>
				</ao-btn>
			</slot>
		</div>
	</div>
</template>

<script>
export default {
	name: 'EmptyStateBlock',
	props: {
		title: {
			type: String,
			default: '',
		},
		subtitle: {
			type: String,
			default: '',
		},
		showButton: {
			type: Boolean,
		},
		iconName: {
			type: String,
		},
	},
	emit: { 'click:action': null },
}
</script>

<style lang="scss">
.empty-state-block {
	.icon {
		color: #7e9aaf;
		font-size: 54px;
		margin-bottom: 24px;
	}
}
</style>
